'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var BundlrStorageDriver = require('./BundlrStorageDriver.cjs');

const bundlrStorage = (options = {}) => ({
  install(metaplex) {
    metaplex.storage().setDriver(new BundlrStorageDriver.BundlrStorageDriver(metaplex, options));
  }
});

exports.bundlrStorage = bundlrStorage;
//# sourceMappingURL=plugin.cjs.map
